<section class="vh-100 bg-image">
    <div class="container h-100">
        <div class="row d-flex h-100 justify-content-center align-items-center">
            <div class="col-md-6">
                <div class="card shadow">
                    <div class="card-body">
                        <h3 class="text-center">Unable To Login</h3>
                        <form name="loginForm" (ngSubmit)="onSubmit()" #loginForm="ngForm" novalidate>

                            <!-- Email Field -->
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" class="form-control" name="email" id="email"
                                    [(ngModel)]="login.email" #email="ngModel" required
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && email.errors }">
                                <div *ngIf="loginForm.submitted && email.errors" class="invalid-feedback">
                                    <div *ngIf="email.errors['required']">Email is required</div>
                                    <div *ngIf="email.errors['email']">Please enter a valid email address</div>
                                </div>
                            </div>

                            <div class="text-center m-2">
                                <button type="submit" class="btn btn-primary"
                                    [disabled]="loginForm.invalid">Login</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>